"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WatchHistoryTable = void 0;
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const styled_components_1 = __importStar(require("styled-components"));
const common_1 = require("../../../../../common");
const GlobalStateProvider_1 = require("../../../../../GlobalStateProvider");
const server_1 = require("../../../../../server");
const WatchHistoryTableStyled = styled_components_1.default.div `
	min-height: 284px;
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 12px;

	.table-item-wrap {
		flex-direction: column;
	}

	.live-list-005 {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: center;
		justify-content: flex-start;
		flex: 1;
		position: relative;

		.table-header {
			background: var(--color-silver, #f3f4f8);
			border-style: solid;
			border-color: var(--color-grey-w, #b6bac0);
			border-width: 1px 0px 0px 0px;
			padding: 10px 16px 10px 16px;
			display: flex;
			flex-direction: row;
			gap: 20px;
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;

			p {
				color: var(--color-black, #101010);
				text-align: left;
				font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
				font-size: var(--b4-font-size, 14px);
				line-height: var(--b4-line-height, 28px);
				letter-spacing: var(--b4-letter-spacing, -0.02em);
				font-weight: var(--b4-font-weight, 400);
				position: relative;
			}
		}

		.item {
			display: flex;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;

			.body-item {
				span {
					color: var(--color-black, #101010);
					text-align: left;
					font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);

					letter-spacing: var(--b4-letter-spacing, -0.02em);
					font-weight: var(--b4-font-weight, 400);
					position: relative;
				}
			}
		}
	}

	.scroll-content {
		flex: 1;
		display: flex;
		flex-direction: column;
	}

	/* 성명(ID) — 아이디는 한 톤 연하게 */
	.idf {
		color: var(--color-grey-l, #83868a) !important;
		margin-left: 1px;
	}

	.empty_data {
		height: unset;
	}

	/* 일부 공개 + 대상자 0명 — 목록 영역 가운데 안내 */
	.empty_data.no_target {
		flex: 1;
		min-height: 200px;
		display: flex;
		align-items: center;
		justify-content: center;
		text-align: center;
	}

	${props => (props.$isMobile ? mobileStyles : desktopStyles)}
`;
const mobileStyles = (0, styled_components_1.css) `
	.live-list-005 {
		.item {
			border-style: solid;
			border-color: var(--color-silver, #f3f4f8);
			border-width: 1px 0px 0px 0px;
			padding: 12px 0px 12px 0px;
			align-items: flex-start;
		}

		.scroll-content {
			overflow: unset;
		}

		.empty_data {
			border-style: solid;
			border-color: var(--color-grey-c, #e6e8ed);
			border-width: 1px 0px 0px 0px;
			padding-top: 16px;
		}

		.mobile_item {
			flex-direction: column;
			.body-item {
				span {
					font-size: var(--b4-font-size, 12px);
					line-height: 150%;
				}
			}
		}
	}

	.watch-history-wrap {
		display: flex;
		flex-direction: column;
		.bold {
			font-family: 'Noto Sans KR', sans-serif;
			font-weight: 700 !important;
			font-size: 14px;
		}
	}

	.wtach-date-wrap {
		display: flex;
		gap: 10px;
	}
	.watch-time-wrap {
		display: flex;
		gap: 4px;
		.overText {
			color: var(--color-grey-l, #83868a) !important;
		}
	}

	.table-item-wrap {
		display: flex;
	}
`;
const desktopStyles = (0, styled_components_1.css) `
	.live-list-005 {
		.item {
			padding: 8px 16px 8px 16px;
			flex-direction: row;
			align-items: center;
			gap: 20px;

			.body-item {
				span {
					font-size: var(--b4-font-size, 14px);
					line-height: var(--b4-line-height, 28px);
				}
			}
		}
	}
`;
/**
 * noTarget: 일부 공개인데 공개 대상자가 0명 — 서버 시청 이력 응답과 무관하게 빈 목록 + 안내 문구.
 * (대상자 없이 받아 온 이력은 대상자 기준이 아니라 목록에 보일 데이터가 아니다)
 */
exports.WatchHistoryTable = react_1.default.memo(({ id, noTarget = false }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isMobile, isTablet, isDesktop } = (0, GlobalStateProvider_1.useGlobalState)();
    const [testData, setTestData] = react_1.default.useState([]);
    const [page, setPage] = react_1.default.useState(0);
    const [totalCount, setTotalCount] = react_1.default.useState(100);
    const [checkedList, setCheckedList] = react_1.default.useState([]);
    const { headTitleList, tableReadDataKeys } = react_1.default.useMemo(() => {
        const headTitleList = [
            { title: 'nameId', space: 2, sort: false },
            { title: 'isWatching', space: 1, sort: false },
            { title: 'watchtime', space: 1, sort: false },
            { title: 'recentWatchDate', space: 1, sort: false },
        ];
        const tableReadDataKeys = [
            { title: 'user_name', space: 2 },
            { title: 'isWatching', space: 1 },
            { title: 'total_streaming_play_duration', space: 1 },
            { title: 'last_streaming_play_time', space: 1 },
        ];
        return { headTitleList, tableReadDataKeys };
    }, []);
    const { data, refetch } = (0, server_1.useWatchHistoryList)({
        id: id,
        // media_id,
        offset: page * 10,
        limit: 10,
    });
    (0, react_1.useEffect)(() => {
        if (noTarget)
            return;
        refetch();
    }, [id, page, noTarget]);
    (0, react_1.useEffect)(() => {
        if (!noTarget && data) {
            const { items, total_count } = data;
            if (total_count > 0) {
                setTestData(items);
                setTotalCount(total_count);
                return;
            }
        }
        setTestData([]);
        setTotalCount(0);
    }, [data, noTarget]);
    const handlerMoreData = (page) => {
        setPage(page);
    };
    const handlerSelectItem = (item) => {
        APP.eventManager.publish('UPDATE_DETAIL_MENU', {
            menuDetail: 'detail',
            id: item.id,
        });
    };
    // Title 가져오기
    const renderTitle = (0, react_1.useMemo)(() => {
        return (react_1.default.createElement("div", { className: "task-label" }, t('conference.watchHistory', { count: totalCount })));
    }, [totalCount]);
    const renderEmpty = (0, react_1.useMemo)(() => noTarget ? (react_1.default.createElement("div", { className: "empty_data no_target" }, "\uB4F1\uB85D\uB41C \uB300\uC0C1\uC790\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.")) : (totalCount === 0 && react_1.default.createElement("div", { className: "empty_data" }, "\uC2DC\uCCAD\uAE30\uB85D\uC774 \uC5C6\uC2B5\uB2C8\uB2E4")), [totalCount, noTarget]);
    const msToTime = (duration) => {
        const milliseconds = (duration % 1000) / 100, seconds = Math.floor((duration / 1000) % 60), minutes = Math.floor((duration / (1000 * 60)) % 60), hours = Math.floor((duration / (1000 * 60 * 60)) % 24);
        const hoursStr = hours < 10 ? '0' + hours : hours;
        const minutesStr = minutes < 10 ? '0' + minutes : minutes;
        const secondsStr = seconds < 10 ? '0' + seconds : seconds;
        return hoursStr + ':' + minutesStr + ':' + secondsStr;
    };
    // Item 가져오기
    const renderItem = (item, styles) => {
        return tableReadDataKeys.map((headItem, index) => isMobile &&
            (headItem.title === 'user_name' ||
                headItem.title === 'last_streaming_play_time') ? null : (react_1.default.createElement("div", { key: index, className: `body-item `, style: {
                flex: isMobile ? 'unset' : headItem.space,
                cursor: 'pointer',
            } }, headItem.title === 'isWatching' ? (isMobile ? (react_1.default.createElement("div", { className: "watch-history-wrap" },
            react_1.default.createElement("span", { className: "overText" },
                item['user_name'],
                item['user_idf'] && react_1.default.createElement("span", { className: "idf" },
                    "(",
                    item['user_idf'],
                    ")")),
            react_1.default.createElement("span", { className: "overText bold" }, item['total_streaming_play_duration'] ? '시청' : '미시청'))) : (react_1.default.createElement("span", { className: "overText" }, item['total_streaming_play_duration'] ? '시청' : '미시청'))) : headItem.title === 'total_streaming_play_duration' ? (isMobile ? (react_1.default.createElement("div", { className: "wtach-date-wrap" },
            react_1.default.createElement("div", { className: "watch-time-wrap" },
                react_1.default.createElement("span", { className: "overText" }, "\uC2DC\uCCAD\uC2DC\uAC04 : "),
                react_1.default.createElement("span", { className: "overText" }, item[headItem.title]
                    ? (0, moment_1.default)(item[headItem.title]).format('YYYY-MM-DD, HH:mm')
                    : '-')),
            react_1.default.createElement("div", { className: "watch-time-wrap" },
                react_1.default.createElement("span", { className: "overText" }, "\uCD5C\uADFC\uC2DC\uCCAD\uC77C\uC790 : "),
                react_1.default.createElement("span", { className: "overText" }, msToTime(item[headItem.title]))))) : (react_1.default.createElement("span", { className: "overText" }, msToTime(item[headItem.title])))) : headItem.title === 'last_streaming_play_time' ? (react_1.default.createElement("span", { className: "overText" }, item[headItem.title]
            ? (0, moment_1.default)(item[headItem.title]).format('YYYY-MM-DD, HH:mm')
            : '-')) : headItem.title === 'user_name' ? (
        // 성명(ID) — 동명이인 구분. play-histories 응답의 user_idf 사용
        react_1.default.createElement("span", { className: "overText" },
            item['user_name'],
            item['user_idf'] && react_1.default.createElement("span", { className: "idf" },
                "(",
                item['user_idf'],
                ")"))) : (react_1.default.createElement("span", { className: "overText" }, item[headItem.title])))));
    };
    return (react_1.default.createElement("div", { className: "field-global-001 date-wrap" },
        react_1.default.createElement("div", { className: "fext-field", style: { gap: 14 } },
            react_1.default.createElement(WatchHistoryTableStyled, { "$isMobile": isMobile, "$isTablet": isTablet, "$isDesktop": isDesktop, className: "not_sticky" },
                react_1.default.createElement(common_1.Table, { className: "live-list-005", 
                    // pagingCount={3}
                    showIndex: isMobile ? false : true, indexOrder: "desc", showCheckBox: false, isInfinite: false, headTitleList: headTitleList, data: testData, page: page, pagingCount: isMobile ? 3 : isTablet ? 5 : 10, totalCount: totalCount, renderTitle: renderTitle, renderEmpty: renderEmpty, renderItem: renderItem, handlerCheckList: setCheckedList, handlerMoreData: handlerMoreData, 
                    // handlerSelectItem={handlerSelectItem}
                    forceShowheader: isMobile ? false : true, padding: false })))));
});
